import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import ui from "@alpinejs/ui";
import intersect from "@alpinejs/intersect";
import persist from "@alpinejs/persist";
import focus from "@alpinejs/focus";
import { tns } from "tiny-slider/src/tiny-slider";

window.tns = tns

export default function () {
    window.Alpine = Alpine;
    Alpine.plugin(ui);
    Alpine.plugin(intersect);
    Alpine.plugin(persist);
    Alpine.plugin(focus);
    Alpine.plugin(collapse);
    Alpine.start();

}